module.exports = __webpack_public_path__ + "img/generic-intermediate-event.ba2e1d71.svg";